import React, { useState } from 'react';
import SliderButton from '@components/position/jd/common/SliderButton';
import InfoListItem from '@components/position/jd/companyInfo/infoListItem';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import classnames from 'classnames/bind';
import styles from './infoList.module.scss';

const cx = classnames.bind(styles);

interface InfoListProps {
  positionDetail: PositionDetailVO;
}

const InfoList = ({ positionDetail }: InfoListProps) => {
  const [infoIndex, setInfoIndex] = useState(0);
  const itemNumber = 3;
  if (!positionDetail) return null;

  const { companyInfo } = positionDetail;
  const {
    ceoName,
    averageSalary,
    averageSalaryText,
    numberOfEmployees,
    numberOfEmployeesText,
    businessSizeText,
    revenueText,
    location,
    establishDateText,
  } = companyInfo;
  const infoCount = 7;

  const cardSize = 200;
  const cardViewCount = itemNumber;
  const isPrev = infoIndex > 0;
  const isNext = infoIndex < infoCount - cardViewCount;

  const handlePrev = () => {
    setInfoIndex(infoIndex - 1);
  };

  const handleNext = () => {
    setInfoIndex(infoIndex + 1);
  };

  return (
    <div className={cx('companyInfoArea')}>
      <SliderButton visible={isPrev} type={'prev'} handleClick={handlePrev} top={48} />
      <div className={cx('companyInfoListWrap')}>
        <ul style={{ transform: `translateX(${-infoIndex * cardSize}px)` }} className={cx('companyInfoList')}>
          <InfoListItem type={'ceo'} title={<span>{ceoName}</span>} />
          <InfoListItem
            type={'salary'}
            title={(
              <span>
                {averageSalaryText}
                {!!averageSalary && <span className={cx('unit')}>원</span>}
              </span>
            )}
          />
          <InfoListItem
            type={'employee'}
            title={(
              <span>
                {numberOfEmployeesText}
                {!!numberOfEmployees && <span className={cx('unit')}>명</span>}
              </span>
            )}
          />
          <InfoListItem type={'enterprise'} title={<span>{businessSizeText}</span>} />
          <InfoListItem type={'take'} title={<span>{revenueText}</span>} />
          <InfoListItem type={'location'} title={<span>{location}</span>} />
          <InfoListItem type={'establish'} title={<span>{establishDateText}</span>} />
        </ul>
      </div>
      <SliderButton visible={isNext} type={'next'} handleClick={handleNext} top={48} />
    </div>
  );
};

export default InfoList;
